import { render, staticRenderFns } from "./AskMessage.vue?vue&type=template&id=bbbe8d8e&scoped=true&"
import script from "./AskMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskMessage.vue?vue&type=style&index=0&id=bbbe8d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbe8d8e",
  null
  
)

export default component.exports